import React from 'react';

const StepTitleItem = props => (
  <div className="StepTitleItem" >
    <div >
      {`ステップ ${props.number}`}
    </div>
  </div>
);

export default StepTitleItem;
